var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.6 52.6",
    style: {
      enableBackground: "new 0 0 52.6 52.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B6B6B6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.4,52.6c-3.5,0-6.8-1.4-9.3-3.9S1.2,43,1.2,39.4c0-3.5,1.4-6.8,3.9-9.3L32.3,2.8c3.9-3.9,10-3.7,14.1,0.4 s4.3,10.2,0.4,14.1L21.2,43c-2.4,2.4-6.3,2.4-8.7,0c-2.4-2.4-2.4-6.3,0-8.7l17.4-17.4c0.6-0.6,1.5-0.6,2.1,0s0.6,1.5,0,2.1 L14.6,36.4c-1.2,1.2-1.2,3.3,0,4.5c1.2,1.2,3.3,1.2,4.5,0l25.6-25.6c2.7-2.7,2.5-6.9-0.4-9.9s-7.2-3.1-9.9-0.4L7.2,32.2 c-1.9,1.9-3,4.5-3,7.2c0,2.7,1.1,5.3,3,7.2s4.5,3,7.2,3c2.7,0,5.3-1.1,7.2-3l27.3-27.3c0.6-0.6,1.5-0.6,2.1,0s0.6,1.5,0,2.1 L23.7,48.8C21.2,51.3,17.9,52.6,14.4,52.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.28a38d9bbc715f1fac4842a22282f193.svg";
export { ForwardRef as ReactComponent };